import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SettingOptionsModalContainer } from './settingOptionsModal';
import {
    change_app_setting_content,
    change_app_setting_point_modal,
    change_app_setting_right_modal,
    change_app_setting_sidebar,
} from '../actions/previewSideBar';
import { ShopCaseLink } from '../../shop/components/shopCase';
import { GalleryContainer } from '../../images/components/gallery';
import { SelectPointLink } from '../../points';
import { QR } from 'app/modules/qr';

function parseProps(props) {
    return {};
}

class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = parseProps(props);
        this.modalLine = this.modalLine.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }

    modalLine(content) {
        return <div className="modal-line mt-4">{content}</div>;
    }

    changeInput(event) {
        let id = event.target.id;
        let state = {};
        state[id] = event.target.value;
        this.setState({ ...state });
    }

    render() {
        const props = this.props,
            class_name_line = 'w-100 btn btn-light pointer-no-select text-left';
        // let isFetching = props.modal.isFetching;
        // let isInvalid = props.modal.didInvalidate;
        return (
            <div>
                <div className="modal-scroll">
                    {this.modalLine(
                        <div
                            className={class_name_line}
                            onClick={() =>
                                props.openSettingSideBar(
                                    'Настройки левого блока',
                                    {
                                        action_type: change_app_setting_sidebar,
                                        option_name: 'sidebar',
                                        settings: props.settings.sidebar,
                                        groups: [
                                            {
                                                header: 'Общий фон',
                                                badge: 1,
                                                lines: [
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Пользователь',
                                                badge: 2,
                                                lines: [
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'itemUser.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Гранцы входа (выбор филиала):',
                                                        property_name:
                                                            'itemUser.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Корзина',
                                                badge: 3,
                                                lines: [
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'itemShop.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'itemShop.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Корзина:',
                                                        property_name:
                                                            'itemShop.colorSvg',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Границы:',
                                                        property_name:
                                                            'itemShop.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Блок категорий',
                                                badge: 7,
                                                lines: [
                                                    {
                                                        header: 'Вид:',
                                                        property_name:
                                                            'types.viewList',
                                                        type: 'radio',
                                                        width: 100,
                                                        values: [
                                                            {
                                                                name: 'Компактный',
                                                                value: 0,
                                                            },
                                                            {
                                                                name: 'Плитки',
                                                                value: 1,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Общий фон:',
                                                        property_name:
                                                            'types.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон категорий:',
                                                        property_name:
                                                            'types.typeCard.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст категорий:',
                                                        property_name:
                                                            'types.typeCard.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Границы категорий:',
                                                        property_name:
                                                            'types.typeCard.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Подкатегории:',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон подкатегорий:',
                                                        property_name:
                                                            'types.typeCard.backgroundSub',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст подкатегорий:',
                                                        property_name:
                                                            'types.typeCard.colorSub',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Границы подкатегорий:',
                                                        property_name:
                                                            'types.typeCard.borderColorSub',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Указатель выбранной категории:',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'types.typeCard.flag.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'types.typeCard.flag.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Границы:',
                                                        property_name:
                                                            'types.typeCard.flag.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                ],
                                            },
                                        ],
                                    }
                                )
                            }
                        >
                            Левый блок (меню)
                        </div>
                    )}
                    {this.modalLine(
                        <div
                            className={class_name_line}
                            onClick={() => {
                                props.openSettingSideBar('Настройки контента', {
                                    action_type: change_app_setting_content,
                                    option_name: 'content',
                                    settings: props.settings.content,
                                    groups: [
                                        {
                                            header: 'Общие',
                                            badge: 5,
                                            lines: [
                                                {
                                                    header: 'Фон:',
                                                    property_name:
                                                        'primary.background',
                                                    type: 'color',
                                                    color_style: 'background',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'favicon - значок веб-сайта (ссылка):',
                                                    property_name:
                                                        'navbar.favicon',
                                                    type: 'input',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Избранные страны телефона:',
                                                    property_name:
                                                        'primary.countries',
                                                    type: 'select',
                                                    multiple: true,
                                                    values: [
                                                        {
                                                            value: 'af',
                                                            name: 'Afghanistan (‫افغانستان‬‎)',
                                                        },
                                                        {
                                                            value: 'al',
                                                            name: 'Albania (Shqipëri)',
                                                        },
                                                        {
                                                            value: 'dz',
                                                            name: 'Algeria (‫الجزائر‬‎)',
                                                        },
                                                        {
                                                            value: 'as',
                                                            name: 'American Samoa',
                                                        },
                                                        {
                                                            value: 'ad',
                                                            name: 'Andorra',
                                                        },
                                                        {
                                                            value: 'ao',
                                                            name: 'Angola',
                                                        },
                                                        {
                                                            value: 'ai',
                                                            name: 'Anguilla',
                                                        },
                                                        {
                                                            value: 'ag',
                                                            name: 'Antigua and Barbuda',
                                                        },
                                                        {
                                                            value: 'ar',
                                                            name: 'Argentina',
                                                        },
                                                        {
                                                            value: 'am',
                                                            name: 'Armenia (Հայաստան)',
                                                        },
                                                        {
                                                            value: 'aw',
                                                            name: 'Aruba',
                                                        },
                                                        {
                                                            value: 'au',
                                                            name: 'Australia',
                                                        },
                                                        {
                                                            value: 'at',
                                                            name: 'Austria (Österreich)',
                                                        },
                                                        {
                                                            value: 'az',
                                                            name: 'Azerbaijan (Azərbaycan)',
                                                        },
                                                        {
                                                            value: 'bs',
                                                            name: 'Bahamas',
                                                        },
                                                        {
                                                            value: 'bh',
                                                            name: 'Bahrain (‫البحرين‬‎)',
                                                        },
                                                        {
                                                            value: 'bd',
                                                            name: 'Bangladesh (বাংলাদেশ)',
                                                        },
                                                        {
                                                            value: 'bb',
                                                            name: 'Barbados',
                                                        },
                                                        {
                                                            value: 'by',
                                                            name: 'Belarus (Беларусь)',
                                                        },
                                                        {
                                                            value: 'be',
                                                            name: 'Belgium (België)',
                                                        },
                                                        {
                                                            value: 'bz',
                                                            name: 'Belize',
                                                        },
                                                        {
                                                            value: 'bj',
                                                            name: 'Benin (Bénin)',
                                                        },
                                                        {
                                                            value: 'bm',
                                                            name: 'Bermuda',
                                                        },
                                                        {
                                                            value: 'bt',
                                                            name: 'Bhutan (འབྲུག)',
                                                        },
                                                        {
                                                            value: 'bo',
                                                            name: 'Bolivia',
                                                        },
                                                        {
                                                            value: 'ba',
                                                            name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
                                                        },
                                                        {
                                                            value: 'bw',
                                                            name: 'Botswana',
                                                        },
                                                        {
                                                            value: 'br',
                                                            name: 'Brazil (Brasil)',
                                                        },
                                                        {
                                                            value: 'io',
                                                            name: 'British Indian Ocean Territory',
                                                        },
                                                        {
                                                            value: 'vg',
                                                            name: 'British Virgin Islands',
                                                        },
                                                        {
                                                            value: 'bn',
                                                            name: 'Brunei',
                                                        },
                                                        {
                                                            value: 'bg',
                                                            name: 'Bulgaria (България)',
                                                        },
                                                        {
                                                            value: 'bf',
                                                            name: 'Burkina Faso',
                                                        },
                                                        {
                                                            value: 'bi',
                                                            name: 'Burundi (Uburundi)',
                                                        },
                                                        {
                                                            value: 'kh',
                                                            name: 'Cambodia (កម្ពុជា)',
                                                        },
                                                        {
                                                            value: 'cm',
                                                            name: 'Cameroon (Cameroun)',
                                                        },
                                                        {
                                                            value: 'ca',
                                                            name: 'Canada',
                                                        },
                                                        {
                                                            value: 'cv',
                                                            name: 'Cape Verde (Kabu Verdi)',
                                                        },
                                                        {
                                                            value: 'bq',
                                                            name: 'Caribbean Netherlands',
                                                        },
                                                        {
                                                            value: 'ky',
                                                            name: 'Cayman Islands',
                                                        },
                                                        {
                                                            value: 'cf',
                                                            name: 'Central African Republic (République centrafricaine)',
                                                        },
                                                        {
                                                            value: 'td',
                                                            name: 'Chad (Tchad)',
                                                        },
                                                        {
                                                            value: 'cl',
                                                            name: 'Chile',
                                                        },
                                                        {
                                                            value: 'cn',
                                                            name: 'China (中国)',
                                                        },
                                                        {
                                                            value: 'cx',
                                                            name: 'Christmas Island',
                                                        },
                                                        {
                                                            value: 'cc',
                                                            name: 'Cocos (Keeling) Islands',
                                                        },
                                                        {
                                                            value: 'co',
                                                            name: 'Colombia',
                                                        },
                                                        {
                                                            value: 'km',
                                                            name: 'Comoros (‫جزر القمر‬‎)',
                                                        },
                                                        {
                                                            value: 'cd',
                                                            name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
                                                        },
                                                        {
                                                            value: 'cg',
                                                            name: 'Congo (Republic) (Congo-Brazzaville)',
                                                        },
                                                        {
                                                            value: 'ck',
                                                            name: 'Cook Islands',
                                                        },
                                                        {
                                                            value: 'cr',
                                                            name: 'Costa Rica',
                                                        },
                                                        {
                                                            value: 'ci',
                                                            name: 'Côte d’Ivoire',
                                                        },
                                                        {
                                                            value: 'hr',
                                                            name: 'Croatia (Hrvatska)',
                                                        },
                                                        {
                                                            value: 'cu',
                                                            name: 'Cuba',
                                                        },
                                                        {
                                                            value: 'cw',
                                                            name: 'Curaçao',
                                                        },
                                                        {
                                                            value: 'cy',
                                                            name: 'Cyprus (Κύπρος)',
                                                        },
                                                        {
                                                            value: 'cz',
                                                            name: 'Czech Republic (Česká republika)',
                                                        },
                                                        {
                                                            value: 'dk',
                                                            name: 'Denmark (Danmark)',
                                                        },
                                                        {
                                                            value: 'dj',
                                                            name: 'Djibouti',
                                                        },
                                                        {
                                                            value: 'dm',
                                                            name: 'Dominica',
                                                        },
                                                        {
                                                            value: 'do',
                                                            name: 'Dominican Republic (República Dominicana)',
                                                        },
                                                        {
                                                            value: 'ec',
                                                            name: 'Ecuador',
                                                        },
                                                        {
                                                            value: 'eg',
                                                            name: 'Egypt (‫مصر‬‎)',
                                                        },
                                                        {
                                                            value: 'sv',
                                                            name: 'El Salvador',
                                                        },
                                                        {
                                                            value: 'gq',
                                                            name: 'Equatorial Guinea (Guinea Ecuatorial)',
                                                        },
                                                        {
                                                            value: 'er',
                                                            name: 'Eritrea',
                                                        },
                                                        {
                                                            value: 'ee',
                                                            name: 'Estonia (Eesti)',
                                                        },
                                                        {
                                                            value: 'et',
                                                            name: 'Ethiopia',
                                                        },
                                                        {
                                                            value: 'fk',
                                                            name: 'Falkland Islands (Islas Malvinas)',
                                                        },
                                                        {
                                                            value: 'fo',
                                                            name: 'Faroe Islands (Føroyar)',
                                                        },
                                                        {
                                                            value: 'fj',
                                                            name: 'Fiji',
                                                        },
                                                        {
                                                            value: 'fi',
                                                            name: 'Finland (Suomi)',
                                                        },
                                                        {
                                                            value: 'fr',
                                                            name: 'France',
                                                        },
                                                        {
                                                            value: 'gf',
                                                            name: 'French Guiana (Guyane française)',
                                                        },
                                                        {
                                                            value: 'pf',
                                                            name: 'French Polynesia (Polynésie française)',
                                                        },
                                                        {
                                                            value: 'ga',
                                                            name: 'Gabon',
                                                        },
                                                        {
                                                            value: 'gm',
                                                            name: 'Gambia',
                                                        },
                                                        {
                                                            value: 'ge',
                                                            name: 'Georgia (საქართველო)',
                                                        },
                                                        {
                                                            value: 'de',
                                                            name: 'Germany (Deutschland)',
                                                        },
                                                        {
                                                            value: 'gh',
                                                            name: 'Ghana (Gaana)',
                                                        },
                                                        {
                                                            value: 'gi',
                                                            name: 'Gibraltar',
                                                        },
                                                        {
                                                            value: 'gr',
                                                            name: 'Greece (Ελλάδα)',
                                                        },
                                                        {
                                                            value: 'gl',
                                                            name: 'Greenland (Kalaallit Nunaat)',
                                                        },
                                                        {
                                                            value: 'gd',
                                                            name: 'Grenada',
                                                        },
                                                        {
                                                            value: 'gp',
                                                            name: 'Guadeloupe',
                                                        },
                                                        {
                                                            value: 'gu',
                                                            name: 'Guam',
                                                        },
                                                        {
                                                            value: 'gt',
                                                            name: 'Guatemala',
                                                        },
                                                        {
                                                            value: 'gg',
                                                            name: 'Guernsey',
                                                        },
                                                        {
                                                            value: 'gn',
                                                            name: 'Guinea (Guinée)',
                                                        },
                                                        {
                                                            value: 'gw',
                                                            name: 'Guinea-Bissau (Guiné Bissau)',
                                                        },
                                                        {
                                                            value: 'gy',
                                                            name: 'Guyana',
                                                        },
                                                        {
                                                            value: 'ht',
                                                            name: 'Haiti',
                                                        },
                                                        {
                                                            value: 'hn',
                                                            name: 'Honduras',
                                                        },
                                                        {
                                                            value: 'hk',
                                                            name: 'Hong Kong (香港)',
                                                        },
                                                        {
                                                            value: 'hu',
                                                            name: 'Hungary (Magyarország)',
                                                        },
                                                        {
                                                            value: 'is',
                                                            name: 'Iceland (Ísland)',
                                                        },
                                                        {
                                                            value: 'in',
                                                            name: 'India (भारत)',
                                                        },
                                                        {
                                                            value: 'id',
                                                            name: 'Indonesia',
                                                        },
                                                        {
                                                            value: 'ir',
                                                            name: 'Iran (‫ایران‬‎)',
                                                        },
                                                        {
                                                            value: 'iq',
                                                            name: 'Iraq (‫العراق‬‎)',
                                                        },
                                                        {
                                                            value: 'ie',
                                                            name: 'Ireland',
                                                        },
                                                        {
                                                            value: 'im',
                                                            name: 'Isle of Man',
                                                        },
                                                        {
                                                            value: 'il',
                                                            name: 'Israel (‫ישראל‬‎)',
                                                        },
                                                        {
                                                            value: 'it',
                                                            name: 'Italy (Italia)',
                                                        },
                                                        {
                                                            value: 'jm',
                                                            name: 'Jamaica',
                                                        },
                                                        {
                                                            value: 'jp',
                                                            name: 'Japan (日本)',
                                                        },
                                                        {
                                                            value: 'je',
                                                            name: 'Jersey',
                                                        },
                                                        {
                                                            value: 'jo',
                                                            name: 'Jordan (‫الأردن‬‎)',
                                                        },
                                                        {
                                                            value: 'kz',
                                                            name: 'Kazakhstan (Казахстан)',
                                                        },
                                                        {
                                                            value: 'ke',
                                                            name: 'Kenya',
                                                        },
                                                        {
                                                            value: 'ki',
                                                            name: 'Kiribati',
                                                        },
                                                        {
                                                            value: 'xk',
                                                            name: 'Kosovo',
                                                        },
                                                        {
                                                            value: 'kw',
                                                            name: 'Kuwait (‫الكويت‬‎)',
                                                        },
                                                        {
                                                            value: 'kg',
                                                            name: 'Kyrgyzstan (Кыргызстан)',
                                                        },
                                                        {
                                                            value: 'la',
                                                            name: 'Laos (ລາວ)',
                                                        },
                                                        {
                                                            value: 'lv',
                                                            name: 'Latvia (Latvija)',
                                                        },
                                                        {
                                                            value: 'lb',
                                                            name: 'Lebanon (‫لبنان‬‎)',
                                                        },
                                                        {
                                                            value: 'ls',
                                                            name: 'Lesotho',
                                                        },
                                                        {
                                                            value: 'lr',
                                                            name: 'Liberia',
                                                        },
                                                        {
                                                            value: 'ly',
                                                            name: 'Libya (‫ليبيا‬‎)',
                                                        },
                                                        {
                                                            value: 'li',
                                                            name: 'Liechtenstein',
                                                        },
                                                        {
                                                            value: 'lt',
                                                            name: 'Lithuania (Lietuva)',
                                                        },
                                                        {
                                                            value: 'lu',
                                                            name: 'Luxembourg',
                                                        },
                                                        {
                                                            value: 'mo',
                                                            name: 'Macau (澳門)',
                                                        },
                                                        {
                                                            value: 'mk',
                                                            name: 'Macedonia (FYROM) (Македонија)',
                                                        },
                                                        {
                                                            value: 'mg',
                                                            name: 'Madagascar (Madagasikara)',
                                                        },
                                                        {
                                                            value: 'mw',
                                                            name: 'Malawi',
                                                        },
                                                        {
                                                            value: 'my',
                                                            name: 'Malaysia',
                                                        },
                                                        {
                                                            value: 'mv',
                                                            name: 'Maldives',
                                                        },
                                                        {
                                                            value: 'ml',
                                                            name: 'Mali',
                                                        },
                                                        {
                                                            value: 'mt',
                                                            name: 'Malta',
                                                        },
                                                        {
                                                            value: 'mh',
                                                            name: 'Marshall Islands',
                                                        },
                                                        {
                                                            value: 'mq',
                                                            name: 'Martinique',
                                                        },
                                                        {
                                                            value: 'mr',
                                                            name: 'Mauritania (‫موريتانيا‬‎)',
                                                        },
                                                        {
                                                            value: 'mu',
                                                            name: 'Mauritius (Moris)',
                                                        },
                                                        {
                                                            value: 'yt',
                                                            name: 'Mayotte',
                                                        },
                                                        {
                                                            value: 'mx',
                                                            name: 'Mexico (México)',
                                                        },
                                                        {
                                                            value: 'fm',
                                                            name: 'Micronesia',
                                                        },
                                                        {
                                                            value: 'md',
                                                            name: 'Moldova (Republica Moldova)',
                                                        },
                                                        {
                                                            value: 'mc',
                                                            name: 'Monaco',
                                                        },
                                                        {
                                                            value: 'mn',
                                                            name: 'Mongolia (Монгол)',
                                                        },
                                                        {
                                                            value: 'me',
                                                            name: 'Montenegro (Crna Gora)',
                                                        },
                                                        {
                                                            value: 'ms',
                                                            name: 'Montserrat',
                                                        },
                                                        {
                                                            value: 'ma',
                                                            name: 'Morocco (‫المغرب‬‎)',
                                                        },
                                                        {
                                                            value: 'mz',
                                                            name: 'Mozambique (Moçambique)',
                                                        },
                                                        {
                                                            value: 'mm',
                                                            name: 'Myanmar (Burma) (မြန်မာ)',
                                                        },
                                                        {
                                                            value: 'na',
                                                            name: 'Namibia (Namibië)',
                                                        },
                                                        {
                                                            value: 'nr',
                                                            name: 'Nauru',
                                                        },
                                                        {
                                                            value: 'np',
                                                            name: 'Nepal (नेपाल)',
                                                        },
                                                        {
                                                            value: 'nl',
                                                            name: 'Netherlands (Nederland)',
                                                        },
                                                        {
                                                            value: 'nc',
                                                            name: 'New Caledonia (Nouvelle-Calédonie)',
                                                        },
                                                        {
                                                            value: 'nz',
                                                            name: 'New Zealand',
                                                        },
                                                        {
                                                            value: 'ni',
                                                            name: 'Nicaragua',
                                                        },
                                                        {
                                                            value: 'ne',
                                                            name: 'Niger (Nijar)',
                                                        },
                                                        {
                                                            value: 'ng',
                                                            name: 'Nigeria',
                                                        },
                                                        {
                                                            value: 'nu',
                                                            name: 'Niue',
                                                        },
                                                        {
                                                            value: 'nf',
                                                            name: 'Norfolk Island',
                                                        },
                                                        {
                                                            value: 'kp',
                                                            name: 'North Korea (조선 민주주의 인민 공화국)',
                                                        },
                                                        {
                                                            value: 'mp',
                                                            name: 'Northern Mariana Islands',
                                                        },
                                                        {
                                                            value: 'no',
                                                            name: 'Norway (Norge)',
                                                        },
                                                        {
                                                            value: 'om',
                                                            name: 'Oman (‫عُمان‬‎)',
                                                        },
                                                        {
                                                            value: 'pk',
                                                            name: 'Pakistan (‫پاکستان‬‎)',
                                                        },
                                                        {
                                                            value: 'pw',
                                                            name: 'Palau',
                                                        },
                                                        {
                                                            value: 'ps',
                                                            name: 'Palestine (‫فلسطين‬‎)',
                                                        },
                                                        {
                                                            value: 'pa',
                                                            name: 'Panama (Panamá)',
                                                        },
                                                        {
                                                            value: 'pg',
                                                            name: 'Papua New Guinea',
                                                        },
                                                        {
                                                            value: 'py',
                                                            name: 'Paraguay',
                                                        },
                                                        {
                                                            value: 'pe',
                                                            name: 'Peru (Perú)',
                                                        },
                                                        {
                                                            value: 'ph',
                                                            name: 'Philippines',
                                                        },
                                                        {
                                                            value: 'pl',
                                                            name: 'Poland (Polska)',
                                                        },
                                                        {
                                                            value: 'pt',
                                                            name: 'Portugal',
                                                        },
                                                        {
                                                            value: 'pr',
                                                            name: 'Puerto Rico',
                                                        },
                                                        {
                                                            value: 'qa',
                                                            name: 'Qatar (‫قطر‬‎)',
                                                        },
                                                        {
                                                            value: 're',
                                                            name: 'Réunion (La Réunion)',
                                                        },
                                                        {
                                                            value: 'ro',
                                                            name: 'Romania (România)',
                                                        },
                                                        {
                                                            value: 'ru',
                                                            name: 'Russia (Россия)',
                                                        },
                                                        {
                                                            value: 'rw',
                                                            name: 'Rwanda',
                                                        },
                                                        {
                                                            value: 'bl',
                                                            name: 'Saint Barthélemy (Saint-Barthélemy)',
                                                        },
                                                        {
                                                            value: 'sh',
                                                            name: 'Saint Helena',
                                                        },
                                                        {
                                                            value: 'kn',
                                                            name: 'Saint Kitts and Nevis',
                                                        },
                                                        {
                                                            value: 'lc',
                                                            name: 'Saint Lucia',
                                                        },
                                                        {
                                                            value: 'mf',
                                                            name: 'Saint Martin (Saint-Martin (partie française))',
                                                        },
                                                        {
                                                            value: 'pm',
                                                            name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
                                                        },
                                                        {
                                                            value: 'vc',
                                                            name: 'Saint Vincent and the Grenadines',
                                                        },
                                                        {
                                                            value: 'ws',
                                                            name: 'Samoa',
                                                        },
                                                        {
                                                            value: 'sm',
                                                            name: 'San Marino',
                                                        },
                                                        {
                                                            value: 'st',
                                                            name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
                                                        },
                                                        {
                                                            value: 'sa',
                                                            name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
                                                        },
                                                        {
                                                            value: 'sn',
                                                            name: 'Senegal (Sénégal)',
                                                        },
                                                        {
                                                            value: 'rs',
                                                            name: 'Serbia (Србија)',
                                                        },
                                                        {
                                                            value: 'sc',
                                                            name: 'Seychelles',
                                                        },
                                                        {
                                                            value: 'sl',
                                                            name: 'Sierra Leone',
                                                        },
                                                        {
                                                            value: 'sg',
                                                            name: 'Singapore',
                                                        },
                                                        {
                                                            value: 'sx',
                                                            name: 'Sint Maarten',
                                                        },
                                                        {
                                                            value: 'sk',
                                                            name: 'Slovakia (Slovensko)',
                                                        },
                                                        {
                                                            value: 'si',
                                                            name: 'Slovenia (Slovenija)',
                                                        },
                                                        {
                                                            value: 'sb',
                                                            name: 'Solomon Islands',
                                                        },
                                                        {
                                                            value: 'so',
                                                            name: 'Somalia (Soomaaliya)',
                                                        },
                                                        {
                                                            value: 'za',
                                                            name: 'South Africa',
                                                        },
                                                        {
                                                            value: 'kr',
                                                            name: 'South Korea (대한민국)',
                                                        },
                                                        {
                                                            value: 'ss',
                                                            name: 'South Sudan (‫جنوب السودان‬‎)',
                                                        },
                                                        {
                                                            value: 'es',
                                                            name: 'Spain (España)',
                                                        },
                                                        {
                                                            value: 'lk',
                                                            name: 'Sri Lanka (ශ්‍රී ලංකාව)',
                                                        },
                                                        {
                                                            value: 'sd',
                                                            name: 'Sudan (‫السودان‬‎)',
                                                        },
                                                        {
                                                            value: 'sr',
                                                            name: 'Suriname',
                                                        },
                                                        {
                                                            value: 'sj',
                                                            name: 'Svalbard and Jan Mayen',
                                                        },
                                                        {
                                                            value: 'sz',
                                                            name: 'Swaziland',
                                                        },
                                                        {
                                                            value: 'se',
                                                            name: 'Sweden (Sverige)',
                                                        },
                                                        {
                                                            value: 'ch',
                                                            name: 'Switzerland (Schweiz)',
                                                        },
                                                        {
                                                            value: 'sy',
                                                            name: 'Syria (‫سوريا‬‎)',
                                                        },
                                                        {
                                                            value: 'tw',
                                                            name: 'Taiwan (台灣)',
                                                        },
                                                        {
                                                            value: 'tj',
                                                            name: 'Tajikistan',
                                                        },
                                                        {
                                                            value: 'tz',
                                                            name: 'Tanzania',
                                                        },
                                                        {
                                                            value: 'th',
                                                            name: 'Thailand (ไทย)',
                                                        },
                                                        {
                                                            value: 'tl',
                                                            name: 'Timor-Leste',
                                                        },
                                                        {
                                                            value: 'tg',
                                                            name: 'Togo',
                                                        },
                                                        {
                                                            value: 'tk',
                                                            name: 'Tokelau',
                                                        },
                                                        {
                                                            value: 'to',
                                                            name: 'Tonga',
                                                        },
                                                        {
                                                            value: 'tt',
                                                            name: 'Trinidad and Tobago',
                                                        },
                                                        {
                                                            value: 'tn',
                                                            name: 'Tunisia (‫تونس‬‎)',
                                                        },
                                                        {
                                                            value: 'tr',
                                                            name: 'Turkey (Türkiye)',
                                                        },
                                                        {
                                                            value: 'tm',
                                                            name: 'Turkmenistan',
                                                        },
                                                        {
                                                            value: 'tc',
                                                            name: 'Turks and Caicos Islands',
                                                        },
                                                        {
                                                            value: 'tv',
                                                            name: 'Tuvalu',
                                                        },
                                                        {
                                                            value: 'vi',
                                                            name: 'U.S. Virgin Islands',
                                                        },
                                                        {
                                                            value: 'ug',
                                                            name: 'Uganda',
                                                        },
                                                        {
                                                            value: 'ua',
                                                            name: 'Ukraine (Україна)',
                                                        },
                                                        {
                                                            value: 'ae',
                                                            name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
                                                        },
                                                        {
                                                            value: 'gb',
                                                            name: 'United Kingdom',
                                                        },
                                                        {
                                                            value: 'us',
                                                            name: 'United States',
                                                        },
                                                        {
                                                            value: 'uy',
                                                            name: 'Uruguay',
                                                        },
                                                        {
                                                            value: 'uz',
                                                            name: 'Uzbekistan (Oʻzbekiston)',
                                                        },
                                                        {
                                                            value: 'vu',
                                                            name: 'Vanuatu',
                                                        },
                                                        {
                                                            value: 'va',
                                                            name: 'Vatican City (Città del Vaticano)',
                                                        },
                                                        {
                                                            value: 've',
                                                            name: 'Venezuela',
                                                        },
                                                        {
                                                            value: 'vn',
                                                            name: 'Vietnam (Việt Nam)',
                                                        },
                                                        {
                                                            value: 'wf',
                                                            name: 'Wallis and Futuna',
                                                        },
                                                        {
                                                            value: 'eh',
                                                            name: 'Western Sahara (‫الصحراء الغربية‬‎)',
                                                        },
                                                        {
                                                            value: 'ye',
                                                            name: 'Yemen (‫اليمن‬‎)',
                                                        },
                                                        {
                                                            value: 'zm',
                                                            name: 'Zambia',
                                                        },
                                                        {
                                                            value: 'zw',
                                                            name: 'Zimbabwe',
                                                        },
                                                        {
                                                            value: 'ax',
                                                            name: 'Åland Islands',
                                                        },
                                                    ],
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Мета теги и стили HTML:',
                                                    property_name:
                                                        'primary.header',
                                                    type: 'textarea',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Подвал HTML:',
                                                    property_name:
                                                        'primary.footer',
                                                    type: 'textarea',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Скрипты HTML:',
                                                    property_name:
                                                        'primary.scripts',
                                                    type: 'textarea',
                                                    width: 100,
                                                },
                                            ],
                                        },
                                        {
                                            header: 'Верхнее меню',
                                            badge: 7,
                                            lines: [
                                                {
                                                    header: 'Текст:',
                                                    property_name:
                                                        'navbar.color',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Текст при наведении:',
                                                    property_name:
                                                        'navbar.hoverColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Номер телефона (в шапке):',
                                                    property_name:
                                                        'navbar.phone',
                                                    type: 'input',
                                                    width: 100,
                                                },

                                                {
                                                    header: 'Логотип изображение (ссылка):',
                                                    property_name:
                                                        'navbar.logo',
                                                    type: 'input',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Логотип мобильное изображение (ссылка):',
                                                    property_name:
                                                        'navbar.logoMobile',
                                                    type: 'input',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Текст (в шапке):',
                                                    property_name:
                                                        'navbar.text',
                                                    type: 'input',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Корзина для мобильной версии',
                                                },
                                                {
                                                    header: 'Цвет суммы:',
                                                    property_name:
                                                        'navbar.itemShop.colorSum',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Фон суммы:',
                                                    property_name:
                                                        'navbar.itemShop.backgroundSum',
                                                    type: 'color',
                                                    color_style: 'background',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Цвет кол-ва:',
                                                    property_name:
                                                        'navbar.itemShop.color',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Цвет корзины:',
                                                    property_name:
                                                        'navbar.itemShop.colorSvg',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                            ],
                                        },
                                        {
                                            header: 'Главная страница',
                                            badge: 3,
                                            lines: [
                                                {
                                                    header: 'Заголовок страницы:',
                                                    property_name:
                                                        'primary.title',
                                                    type: 'input',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Наименование:',
                                                    property_name:
                                                        'primary.name',
                                                    type: 'input',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Контент HTML:',
                                                    property_name:
                                                        'primary.content',
                                                    type: 'textarea',
                                                    width: 100,
                                                },
                                            ],
                                        },
                                        {
                                            header: 'Слайдер главная страница',
                                            badge: 1,
                                            lines: [
                                                {
                                                    type: 'array',
                                                    add_button:
                                                        'Добавить слайд',
                                                    remove_button:
                                                        'Удалить слайд',
                                                    property_name:
                                                        'primary.carousel_items',
                                                    lines: [
                                                        {
                                                            header: 'Слайд изображение (ссылка)',
                                                            property_name:
                                                                'src',
                                                            type: 'input',
                                                            width: 100,
                                                        },
                                                        {
                                                            header: 'Слайд мобильное изображение (ссылка)',
                                                            property_name:
                                                                'src_mobile',
                                                            type: 'input',
                                                            width: 100,
                                                        },
                                                        {
                                                            header: 'Заголовок слайда',
                                                            property_name:
                                                                'header',
                                                            type: 'input',
                                                            width: 50,
                                                        },
                                                        {
                                                            header: 'Описание слайда',
                                                            property_name:
                                                                'caption',
                                                            type: 'input',
                                                            width: 50,
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            header: 'Дополнительные страницы и слайдер',
                                            badge: 3,
                                            type: 'array',
                                            add_button: 'Добавить страницу',
                                            remove_button: 'Удалить страницу',
                                            property_name: 'pages',
                                            lines: [
                                                {
                                                    type: 'array',
                                                    add_button:
                                                        'Добавить слайд',
                                                    remove_button:
                                                        'Удалить слайд',
                                                    property_name:
                                                        'carousel_items',
                                                    lines: [
                                                        {
                                                            header: 'Слайд изображение (ссылка)',
                                                            property_name:
                                                                'src',
                                                            type: 'input',
                                                            width: 100,
                                                        },
                                                        {
                                                            header: 'Слайд мобильное изображение (ссылка)',
                                                            property_name:
                                                                'src_mobile',
                                                            type: 'input',
                                                            width: 100,
                                                        },
                                                        {
                                                            header: 'Заголовок слайда',
                                                            property_name:
                                                                'header',
                                                            type: 'input',
                                                            width: 50,
                                                        },
                                                        {
                                                            header: 'Описание слайда',
                                                            property_name:
                                                                'caption',
                                                            type: 'input',
                                                            width: 50,
                                                        },
                                                    ],
                                                },
                                                {
                                                    header: 'Заголовок страницы:',
                                                    property_name: 'title',
                                                    type: 'input',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Наименование:',
                                                    property_name: 'name',
                                                    type: 'input',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Контент HTML:',
                                                    property_name: 'content',
                                                    type: 'textarea',
                                                    width: 100,
                                                },
                                            ],
                                        },
                                        {
                                            header: 'Наименование категории',
                                            badge: 1,
                                            lines: [
                                                {
                                                    header: 'Наименование:',
                                                    property_name:
                                                        'products.header.color',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 100,
                                                },
                                            ],
                                        },
                                        {
                                            header: 'Карточка продукта',
                                            badge: 6,
                                            lines: [
                                                {
                                                    header: 'Фон:',
                                                    property_name:
                                                        'products.productCard.background',
                                                    type: 'color',
                                                    color_style: 'background',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Границы:',
                                                    property_name:
                                                        'products.productCard.borderColor',
                                                    type: 'color',
                                                    color_style: 'borderColor',
                                                    width: 50,
                                                },
                                                // {
                                                //     header: 'Границы при наведении:',
                                                //     property_name:
                                                //         'products.productCard.hoverBorderColor',
                                                //     type: 'color',
                                                //     color_style: 'borderColor',
                                                //     width: 50,
                                                // },
                                                {
                                                    header: 'Наименование:',
                                                    property_name:
                                                        'products.productCard.nameColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Описание:',
                                                    property_name:
                                                        'products.productCard.descriptionColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Цена:',
                                                    property_name:
                                                        'products.productCard.infoColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 100,
                                                },
                                                // {
                                                //     header: 'Корзина',
                                                //     width: 100,
                                                //     // 'basketBackground' => '#F2F1F1', // Цвет текста корзины
                                                //     // 'basketTextColor' => '#F2F1F1', // Цвет текста корзины
                                                //     // 'basketColor' => '#F2F1F1', // Цвет корзины
                                                //     // 'basketBorderColor' => '#F2F1F1', // Цвет границ корзины
                                                //     // 'basketHoverBorderColor' => $primary_color, // Цвет границ корзины при наведении на корзину
                                                // },
                                                //         {
                                                //             header: 'Фон:',
                                                //             property_name:
                                                //                 'products.productCard.basketBackground',
                                                //             type: 'color',
                                                //             color_style: 'background',
                                                //             width: 100,
                                                //         },
                                                //         {
                                                //             header: 'Текст:',
                                                //             property_name:
                                                //                 'products.productCard.basketTextColor',
                                                //             type: 'color',
                                                //             color_style: 'color',
                                                //             width: 50,
                                                //         },
                                                //         {
                                                //             header: 'Корзина:',
                                                //             property_name:
                                                //                 'products.productCard.basketColor',
                                                //             type: 'color',
                                                //             color_style: 'color',
                                                //             width: 50,
                                                //         },
                                                //         {
                                                //             header: 'Границы:',
                                                //             property_name:
                                                //                 'products.productCard.basketBorderColor',
                                                //             type: 'color',
                                                //             color_style: 'borderColor',
                                                //             width: 50,
                                                //         },
                                                //         {
                                                //             header: 'Границы при наведении:',
                                                //             property_name:
                                                //                 'products.productCard.basketHoverBorderColor',
                                                //             type: 'color',
                                                //             color_style: 'borderColor',
                                                //             width: 50,
                                                //         },
                                            ],
                                        },
                                        {
                                            header: 'Вид товаров в категории',
                                            badge: 1,
                                            lines: [
                                                {
                                                    header: 'Вид',
                                                    property_name:
                                                        'products.productView',
                                                    type: 'radio',
                                                    width: 100,
                                                    values: [
                                                        {
                                                            name: 'По группам',
                                                            value: 'groups',
                                                        },
                                                        {
                                                            name: 'Списком',
                                                            value: 'list',
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            header: 'Хлебные крошки',
                                            badge: 2,
                                            lines: [
                                                {
                                                    header: 'Выбор цвета ссылки',
                                                    property_name:
                                                        'breadcrumbs.main.commonColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Выбор цвета активной ссылки',
                                                    property_name:
                                                        'breadcrumbs.main.activeColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Выбор цвета ссылки после наведения',
                                                    property_name:
                                                        'breadcrumbs.main.commonHoverColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Выбор цвета активной ссылки после наведения',
                                                    property_name:
                                                        'breadcrumbs.main.activeHoverColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Фон:',
                                                    property_name:
                                                        'breadcrumbs.main.background',
                                                    type: 'color',
                                                    color_style: 'background',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Фон после наведения:',
                                                    property_name:
                                                        'breadcrumbs.main.backgroundHover',
                                                    type: 'color',
                                                    color_style: 'background',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Хлебные крошки внутри карточек товаров',
                                                },
                                                {
                                                    header: 'Выбор цвета',
                                                    property_name:
                                                        'breadcrumbs.modal.commonColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Выбор цвета активной ссылки',
                                                    property_name:
                                                        'breadcrumbs.modal.activeColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Выбор цвета ссылки после наведения',
                                                    property_name:
                                                        'breadcrumbs.modal.commonHoverColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Выбор цвета активной ссылки после наведения',
                                                    property_name:
                                                        'breadcrumbs.modal.activeHoverColor',
                                                    type: 'color',
                                                    color_style: 'color',
                                                    width: 50,
                                                },
                                                {
                                                    header: 'Фон:',
                                                    property_name:
                                                        'breadcrumbs.modal.background',
                                                    type: 'color',
                                                    color_style: 'background',
                                                    width: 100,
                                                },
                                                {
                                                    header: 'Фон после наведения:',
                                                    property_name:
                                                        'breadcrumbs.modal.backgroundHover',
                                                    type: 'color',
                                                    color_style: 'background',
                                                    width: 100,
                                                },
                                            ],
                                        },
                                    ],
                                });
                            }}
                        >
                            Контент (общие)
                        </div>
                    )}
                    {this.modalLine(
                        <div
                            className={class_name_line}
                            onClick={() => {
                                props.openExtraSettingSideBar(
                                    'Настройки формы подтверждения заказа',
                                    {
                                        action_type:
                                            change_app_setting_right_modal,
                                        option_name: 'rightModal',
                                        settings: props.settings.rightModal,
                                        groups: [
                                            {
                                                header: 'Верхний колонтитул',
                                                badge: 6,
                                                lines: [
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'header.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'header.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Кнопки',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'header.button.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон при наведении:',
                                                        property_name:
                                                            'header.button.hoverBackground',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Цвет:',
                                                        property_name:
                                                            'header.button.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Цвет при наведении:',
                                                        property_name:
                                                            'header.button.hoverColor',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Общие',
                                                badge: 4,
                                                lines: [
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'body.secondColor',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Цена:',
                                                        property_name:
                                                            'body.priceColor',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Дополнительный текст:',
                                                        property_name:
                                                            'body.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 100,
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Поля для не авторизованного пользователя',
                                                badge: 12,
                                                lines: [
                                                    {
                                                        header: 'Поле имя',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Наименование:',
                                                        property_name:
                                                            'noAuth.name.title',
                                                        type: 'input',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Отображать?',
                                                        property_name:
                                                            'noAuth.name.visible',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: 'Да',
                                                                value: 1,
                                                            },
                                                            {
                                                                name: 'Нет',
                                                                value: 0,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Обязательное заполнение?',
                                                        property_name:
                                                            'noAuth.name.required',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: 'Да',
                                                                value: 1,
                                                            },
                                                            {
                                                                name: 'Нет',
                                                                value: 0,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Ширина:',
                                                        property_name:
                                                            'noAuth.name.width',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: '25%',
                                                                value: 25,
                                                            },
                                                            {
                                                                name: '50%',
                                                                value: 50,
                                                            },
                                                            {
                                                                name: '75%',
                                                                value: 75,
                                                            },
                                                            {
                                                                name: '100%',
                                                                value: 100,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Поле телефон',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Наименование:',
                                                        property_name:
                                                            'noAuth.phone.title',
                                                        type: 'input',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Отображать?',
                                                        property_name:
                                                            'noAuth.phone.visible',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: 'Да',
                                                                value: 1,
                                                            },
                                                            {
                                                                name: 'Нет',
                                                                value: 0,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Обязательное заполнение?',
                                                        property_name:
                                                            'noAuth.phone.required',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: 'Да',
                                                                value: 1,
                                                            },
                                                            {
                                                                name: 'Нет',
                                                                value: 0,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Ширина:',
                                                        property_name:
                                                            'noAuth.phone.width',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: '25%',
                                                                value: 25,
                                                            },
                                                            {
                                                                name: '50%',
                                                                value: 50,
                                                            },
                                                            {
                                                                name: '75%',
                                                                value: 75,
                                                            },
                                                            {
                                                                name: '100%',
                                                                value: 100,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Поле email',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Наименование:',
                                                        property_name:
                                                            'noAuth.email.title',
                                                        type: 'input',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Отображать?',
                                                        property_name:
                                                            'noAuth.email.visible',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: 'Да',
                                                                value: 1,
                                                            },
                                                            {
                                                                name: 'Нет',
                                                                value: 0,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Обязательное заполнение?',
                                                        property_name:
                                                            'noAuth.email.required',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: 'Да',
                                                                value: 1,
                                                            },
                                                            {
                                                                name: 'Нет',
                                                                value: 0,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Ширина:',
                                                        property_name:
                                                            'noAuth.email.width',
                                                        type: 'radio',
                                                        width: 50,
                                                        values: [
                                                            {
                                                                name: '25%',
                                                                value: 25,
                                                            },
                                                            {
                                                                name: '50%',
                                                                value: 50,
                                                            },
                                                            {
                                                                name: '75%',
                                                                value: 75,
                                                            },
                                                            {
                                                                name: '100%',
                                                                value: 100,
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Наименование полей ввода',
                                                badge: 7,
                                                lines: [
                                                    {
                                                        header: 'Вид:',
                                                        property_name:
                                                            'body.input.type',
                                                        width: 100,
                                                        type: 'radio',
                                                        values: [
                                                            {
                                                                name: 'Компактный',
                                                                value: 0,
                                                            },
                                                            {
                                                                name: 'В две строки',
                                                                value: 1,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        header: 'Если поле не заполнено',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'body.input.icon.inputEmpty.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'body.input.icon.inputEmpty.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Границы:',
                                                        property_name:
                                                            'body.input.icon.inputEmpty.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Если поле заполнено',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'body.input.icon.inputNotEmpty.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'body.input.icon.inputNotEmpty.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Границы:',
                                                        property_name:
                                                            'body.input.icon.inputNotEmpty.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Поля ввода',
                                                badge: 3,
                                                lines: [
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'body.input.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'body.input.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Границы:',
                                                        property_name:
                                                            'body.input.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Поля ввода адреса',
                                                badge: 4,
                                                lines: [
                                                    {
                                                        type: 'array',
                                                        add_button:
                                                            'Добавить поле адреса',
                                                        remove_button:
                                                            'Удалить поле адреса',
                                                        property_name:
                                                            'body.addresses',
                                                        lines: [
                                                            {
                                                                header: 'Поля адреса',
                                                                width: 100,
                                                            },
                                                            {
                                                                header: 'Наименование:',
                                                                property_name:
                                                                    'title',
                                                                type: 'input',
                                                                width: 50,
                                                            },
                                                            {
                                                                header: 'Префикс:',
                                                                property_name:
                                                                    'prefix',
                                                                type: 'input',
                                                                width: 50,
                                                            },
                                                            {
                                                                header: 'Обязательное заполнение?',
                                                                property_name:
                                                                    'required',
                                                                type: 'radio',
                                                                width: 50,
                                                                values: [
                                                                    {
                                                                        name: 'Да',
                                                                        value: 1,
                                                                    },
                                                                    {
                                                                        name: 'Нет',
                                                                        value: 0,
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                header: 'Ширина:',
                                                                property_name:
                                                                    'width',
                                                                type: 'radio',
                                                                width: 50,
                                                                values: [
                                                                    {
                                                                        name: '25%',
                                                                        value: 25,
                                                                    },
                                                                    {
                                                                        name: '50%',
                                                                        value: 50,
                                                                    },
                                                                    {
                                                                        name: '75%',
                                                                        value: 75,
                                                                    },
                                                                    {
                                                                        name: '100%',
                                                                        value: 100,
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Поля ввода комметария',
                                                badge: 5,
                                                lines: [
                                                    {
                                                        type: 'array',
                                                        add_button:
                                                            'Добавить поле комментария',
                                                        remove_button:
                                                            'Удалить поле комментария',
                                                        property_name:
                                                            'body.comments',
                                                        lines: [
                                                            {
                                                                header: 'Поля комментария',
                                                                width: 100,
                                                            },
                                                            {
                                                                header: 'Наименование:',
                                                                property_name:
                                                                    'title',
                                                                type: 'input',
                                                                width: 50,
                                                            },
                                                            {
                                                                header: 'Префикс:',
                                                                property_name:
                                                                    'prefix',
                                                                type: 'input',
                                                                width: 50,
                                                            },
                                                            {
                                                                header: 'Обязательное заполнение?',
                                                                property_name:
                                                                    'required',
                                                                type: 'radio',
                                                                width: 50,
                                                                values: [
                                                                    {
                                                                        name: 'Да',
                                                                        value: 1,
                                                                    },
                                                                    {
                                                                        name: 'Нет',
                                                                        value: 0,
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                header: 'Большое поле?',
                                                                property_name:
                                                                    'textarea',
                                                                type: 'radio',
                                                                width: 50,
                                                                values: [
                                                                    {
                                                                        name: 'Да',
                                                                        value: 1,
                                                                    },
                                                                    {
                                                                        name: 'Нет',
                                                                        value: 0,
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                header: 'Ширина:',
                                                                property_name:
                                                                    'width',
                                                                type: 'radio',
                                                                width: 50,
                                                                values: [
                                                                    {
                                                                        name: '25%',
                                                                        value: 25,
                                                                    },
                                                                    {
                                                                        name: '50%',
                                                                        value: 50,
                                                                    },
                                                                    {
                                                                        name: '75%',
                                                                        value: 75,
                                                                    },
                                                                    {
                                                                        name: '100%',
                                                                        value: 100,
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                header: 'Нижний колонтитул',
                                                badge: 5,
                                                lines: [
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'footer.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Верхняя граница:',
                                                        property_name:
                                                            'footer.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Кнопки',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Фон:',
                                                        property_name:
                                                            'footer.button.background',
                                                        type: 'color',
                                                        color_style:
                                                            'background',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Границы:',
                                                        property_name:
                                                            'footer.button.borderColor',
                                                        type: 'color',
                                                        color_style:
                                                            'borderColor',
                                                        width: 50,
                                                    },
                                                    {
                                                        header: 'Текст:',
                                                        property_name:
                                                            'footer.button.color',
                                                        type: 'color',
                                                        color_style: 'color',
                                                        width: 50,
                                                    },
                                                ],
                                            },
                                        ],
                                    }
                                );
                            }}
                        >
                            Форма подтверждения заказа
                        </div>
                    )}
                    {this.modalLine(
                        <div
                            className={class_name_line}
                            onClick={() => {
                                props.openExtraPointModal(
                                    'Настройки формы выбора точки',
                                    {
                                        action_type:
                                            change_app_setting_point_modal,
                                        option_name: 'pointModal',
                                        settings: props.settings.pointModal,
                                        groups: [
                                            {
                                                header: 'Общие',
                                                badge: 2,
                                                lines: [
                                                    {
                                                        header: 'Заголовок:',
                                                        property_name:
                                                            'body.header',
                                                        type: 'input',
                                                        width: 100,
                                                    },
                                                    {
                                                        header: 'Описание:',
                                                        property_name:
                                                            'body.description',
                                                        type: 'textarea',
                                                        width: 100,
                                                    },
                                                ],
                                            },
                                        ],
                                    }
                                );
                            }}
                        >
                            Форма выбора точки
                        </div>
                    )}
                    {this.modalLine(
                        <div
                            className={class_name_line}
                            onClick={props.openGallery}
                        >
                            Галерея изображений
                        </div>
                    )}
                    {this.modalLine(
                        <div
                            className={class_name_line}
                            onClick={props.openQRCode}
                        >
                            QR Code
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {
        settings: state.appState.setting,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: () => {
            dispatch({ type: 'closeMiniModal' });
        },
        openSettingSideBar: (name, options) => {
            dispatch({
                type: 'openRightModal',
                HeadItem: [name],
                isNoBackground: true,
                children: <SettingOptionsModalContainer options={options} />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
        openGallery: () => {
            dispatch({
                type: 'openRightModal',
                HeadItem: ['Галерея'],
                isNoBackground: true,
                children: <GalleryContainer />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
        openQRCode: () => {
            dispatch({
                type: 'openRightModal',
                HeadItem: ['QR Code'],
                isNoBackground: true,
                children: <QR />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },

        openExtraSettingSideBar: (name, options) => {
            dispatch({ type: 'closeRightModal' });
            dispatch({
                type: 'openRightModal',
                HeadItem: ['Корзина'],
                children: <ShopCaseLink />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
            dispatch({
                type: 'openExtraModal',
                HeadItem: [name],
                children: <SettingOptionsModalContainer options={options} />,
                onClose: () => {
                    dispatch({ type: 'closeExtraModal' });
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
        openExtraPointModal: (name, options) => {
            dispatch({ type: 'closeRightModal' });
            dispatch({
                type: 'openRightModal',
                HeadItem: ['Выбор точки продаж'],
                children: <SelectPointLink edit={true} />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
            dispatch({
                type: 'openExtraModal',
                HeadItem: [name],
                children: <SettingOptionsModalContainer options={options} />,
                onClose: () => {
                    dispatch({ type: 'closeExtraModal' });
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
        dispatch,
    };
};

export const SettingLink = connect(
    MapStateToProps,
    mapDispatchToProps
)(Setting);
